import { gsap, Observer } from "gsap";
import { Observer } from "gsap/Observer";

export function registerPageTransitions() {
  gsap.registerPlugin(Observer);

  const navItems = document.querySelectorAll(".navbar__item");
  const sections = document.querySelectorAll("section");
  const storySections = document.querySelectorAll(".story");
  const images = document.querySelectorAll(".page-content");
  const outerWrappers = gsap.utils.toArray(".outer");
  const innerWrappers = gsap.utils.toArray(".inner");
  const wrap = gsap.utils.wrap(0, sections.length);
  let currentIndex = -1;
  let animating = false;

  gsap.set(outerWrappers, { yPercent: 100 });
  gsap.set(innerWrappers, { yPercent: -100 });

  navItems.forEach((navEl, index) => {
    navEl.addEventListener("click", (e) => {
      e.preventDefault();
      if (animating) {
        return;
      }
      const STORY_SECTION_COUNT = storySections.length;
      const FIRST_STORY_SECTION_INDEX = Array.from(sections).indexOf(
        storySections[0]
      );
      let pageIndex =
        index <= FIRST_STORY_SECTION_INDEX
          ? index
          : index + STORY_SECTION_COUNT - 1;
      const direction = pageIndex > currentIndex ? 1 : -1;

      gotoSection(pageIndex, direction);
      location.hash = sections[pageIndex].id; // Update URL hash
    });
  });

  function updateActiveNavItem(index, direction) {
    // Remove all active classes first
    navItems.forEach((item) => {
      item.classList.remove("navbar__item--active");
      item.classList.remove("navbar__item--active-left");
      item.classList.remove("navbar__item--active-right");
    });

    // Get section ID and match with navbar item
    const currentSectionId = sections[index].id;
    const actualSectionId = currentSectionId.split("_")[0]; // Get the base ID without suffix - for story multiple sections
    const activeNavItem = document.querySelector(
      `.navbar__item a[href="#${actualSectionId}"]`
    ).parentElement;

    // Apply directional class based on scroll direction
    if (
      direction === 1 &&
      !activeNavItem.classList.contains("navbar__item--active-left")
    ) {
      // scrolling down
      activeNavItem.classList.add("navbar__item--active-left");
    } else if (
      !activeNavItem.classList.contains("navbar__item--active-right")
    ) {
      // scrolling up
      activeNavItem.classList.add("navbar__item--active-right");
    }
  }

  function gotoSection(index, direction) {
    index = wrap(index); // make sure it's valid
    animating = true;
    let fromTop = direction === -1,
      dFactor = fromTop ? -1 : 1,
      tl = gsap.timeline({
        defaults: { duration: 1.25, ease: "power1.inOut" },
        onComplete: () => (animating = false),
      });
    if (currentIndex >= 0) {
      // The first time this function runs, current is -1
      gsap.set(sections[currentIndex], { zIndex: 0 });
      tl.to(images[currentIndex], { yPercent: -15 * dFactor }).set(
        sections[currentIndex],
        { autoAlpha: 0 }
      );
    }
    gsap.set(sections[index], { autoAlpha: 1, zIndex: 1 });
    tl.fromTo(
      [outerWrappers[index], innerWrappers[index]],
      {
        yPercent: (i) => (i ? -100 * dFactor : 100 * dFactor),
      },
      {
        yPercent: 0,
      },
      0
    ).fromTo(images[index], { yPercent: 15 * dFactor }, { yPercent: 0 }, 0);
    // .fromTo(
    //   splitHeadings[index].chars,
    //   {
    //     autoAlpha: 0,
    //     yPercent: 150 * dFactor,
    //   },
    //   {
    //     autoAlpha: 1,
    //     yPercent: 0,
    //     duration: 1,
    //     ease: "power2",
    //     stagger: {
    //       each: 0.02,
    //       from: "random",
    //     },
    //   },
    //   0.2
    // );

    currentIndex = index;
    updateActiveNavItem(wrap(index), direction);
  }

  Observer.create({
    type: "wheel,touch,pointer",
    wheelSpeed: -1,
    onDown: () => {
      if (!animating && currentIndex - 1 >= 0) {
        gotoSection(currentIndex - 1, -1);
      }
    },
    onUp: () => {
      if (!animating && currentIndex + 1 < sections.length) {
        gotoSection(currentIndex + 1, 1);
      }
    },
    tolerance: 10,
    preventDefault: true,
  });

  // Get initial section from URL hash or default to first section
  const initialIndex = location.hash
    ? Array.from(sections).findIndex(
        (section) => section.id === location.hash.substring(1)
      )
    : 0;
  gotoSection(initialIndex, 1);
}
